__turbopack_context__.v({
  "footer": "PortalExperience-module__O27nwW__footer",
  "footerActions": "PortalExperience-module__O27nwW__footerActions",
  "footerBrand": "PortalExperience-module__O27nwW__footerBrand",
  "footerName": "PortalExperience-module__O27nwW__footerName",
  "gate": "PortalExperience-module__O27nwW__gate",
  "login": "PortalExperience-module__O27nwW__login",
  "main": "PortalExperience-module__O27nwW__main",
  "page": "PortalExperience-module__O27nwW__page",
  "restrictedMain": "PortalExperience-module__O27nwW__restrictedMain",
});
